import React from 'react';
import ActionBtn from './ActionBtn';

function formatDate(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function VersionTableRow({ version, onEdit, onDelete, deleting }) {
  const lines = version.sql_content.split('\n');
  return (
    <tr
      style={{ borderBottom: '1px solid #1a1c26' }}
      onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.01)'}
      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
    >
      <td className="px-6 py-4 whitespace-nowrap">
        <span className="text-xs font-mono" style={{ color: '#818cf8' }}>{formatDate(version.created_at)}</span>
      </td>
      <td className="px-6 py-4" style={{ maxWidth: 0 }}>
        <p className="text-xs font-mono truncate" style={{ color: '#86efac', opacity: 0.75 }} title={version.sql_content}>
          {lines[0]}
        </p>
        {lines.length > 1 && (
          <p className="text-xs mt-0.5" style={{ color: '#374151' }}>
            +{lines.length - 1} more {lines.length === 2 ? 'line' : 'lines'}
          </p>
        )}
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center justify-end gap-1">
          <ActionBtn variant="blue" onClick={onEdit}>
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6.5-6.5a2 2 0 012.828 2.828L11 16H8v-3z" />
            </svg>
            Edit SQL
          </ActionBtn>
          <ActionBtn variant="red" onClick={onDelete} disabled={deleting}>
            {deleting ? '…' : (
              <>
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Delete
              </>
            )}
          </ActionBtn>
        </div>
      </td>
    </tr>
  );
}
